var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('h' + _vm.level,{tag:"component",class:[_vm.isCentered && 'text--center']},[_vm._v("\n  "+_vm._s(_vm.text)+"\n  "),_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }